import React from 'react'
import { IconButton, Menu, MenuItem } from '@mui/material'
import posthog from 'posthog-js'
import MoreVertIcon from '@mui/icons-material/MoreVert'

const isJobArchived = job => Boolean(job.deletedAt)

const JobActionsMenu = ({ job, onViewJob, onEditJob, onArchiveJob }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const open = Boolean(anchorEl)

  const handleButtonClick = event => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handleClose = event => {
    if (event) event.stopPropagation()
    setAnchorEl(null)
  }

  const handleViewJob = event => {
    posthog.capture('employer_job_view_clicked', { job_id: job.id, job_title: job.title })
    handleClose(event)
    onViewJob(job)
  }

  const handleEdit = event => {
    posthog.capture('employer_job_edit_clicked', { job_id: job.id, job_title: job.title })
    handleClose(event)
    onEditJob(job)
  }

  const handleArchive = event => {
    const action = isJobArchived(job) ? 'restore' : 'archive'
    posthog.capture(`employer_job_${action}_clicked`, { job_id: job.id, job_title: job.title })
    handleClose(event)
    onArchiveJob(job)
  }

  const archived = isJobArchived(job)

  return (
    <>
      <IconButton
        size='small'
        onClick={handleButtonClick}
        aria-label='job actions'
        aria-controls={open ? 'job-actions-menu' : undefined}
        aria-haspopup='true'
        aria-expanded={open ? 'true' : undefined}
      >
        <MoreVertIcon fontSize='small' />
      </IconButton>
      <Menu
        id='job-actions-menu'
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={event => event.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleViewJob}>View Job</MenuItem>
        <MenuItem onClick={handleEdit}>Edit</MenuItem>
        <MenuItem onClick={handleArchive}>{archived ? 'Restore' : 'Archive'}</MenuItem>
      </Menu>
    </>
  )
}

export default JobActionsMenu
